export default "__VITE_ASSET__B$zWxRso__"